import React from 'react'
import FirstIntroduction from './FirstIntroduction';

const FirstUtterance = ({expand, addToMessagAreaFunc}) => {
  const style = expand ? {} : { height: 'auto' };
  return (
    <div
      className="chat-area first-chat"
      style={style}
    >
      <div className="chat-message">
        <div className="message-sender first-message">
          <img src="/img/chat_logo.png" alt="Profile Picture" className="icon h-[15px] w-[15px]"/>
          <p id="introduction-message">チャットで<span className='highlight'>上場企業</span>の分析ができます。</p>
        </div>
        <FirstIntroduction />
      </div>
    </div>
  )
}

export default FirstUtterance